import ReportOperatorProfitList from './report-operator-profit.list';

export default {
  list: ReportOperatorProfitList,
};
